import './LoadingScreen.css';
const LoadingScreen = () => (<div className="spinner">
  <span>Loading...</span>
  <div className="half-spinner"></div>
</div>);

export default LoadingScreen;